module.exports = __webpack_public_path__ + "img/4.38627208.svg";